import * as Scrivito from "scrivito";
import { MediaContainer } from "./MediaContainer";

import "./pageHeaderWidget.scss";

Scrivito.provideComponent("PageHeaderWidget", ({ widget }) => {
  const image = widget.get("image");
  const destination = widget.get("destination");
  const backgroundColor = widget.get("backgroundColor") || "blue";
  const background = widget.get("background");
  const isImage = background
    ?.get("blob")
    .raw()
    .metadata()
    .contentType()
    .startsWith("image");

  const isVideo = background
    ?.get("blob")
    .raw()
    .metadata()
    .contentType()
    .startsWith("video");

  const sectionClassNames = ["page-header-widget", `bg-${backgroundColor}`];

  (isImage || isVideo) &&
    sectionClassNames.push(`bg-${widget.get("backgroundColor")}-blur`);
  let style = { "--opacity": "0.6" };
  if (isImage) {
    style = {
      "--blur-strength": "7px",
      "--opacity": "0.7",
      backgroundImage: `url(${Scrivito.urlFor(background)})`,
    };
  }

  const hasMedia = !!image;
  const mediaClass = hasMedia ? "col-12 col-lg-5" : "";
  const contentClass = hasMedia ? "col-12 col-lg-7" : "col-12";

  return (
    <>
      <div className={sectionClassNames.join(" ")} style={style}>
        {isVideo && (
          <div className="background-video-wrapper">
            <video
              src={Scrivito.urlFor(background)}
              controls={false}
              autoPlay={true}
              muted={true}
              loop={true}
              playsInline
              preload="auto"
            />
          </div>
        )}
        <div className="container">
          <div className="row">
            {hasMedia && (
              <div className={`${mediaClass} position-relative`}>
                <div className="page-header-widget__media">
                  <MediaContainer image={image} lazy={false} />
                </div>
              </div>
            )}
            <div className={contentClass}>
              <Scrivito.ContentTag
                tag="h1"
                className="page-header-widget__headline"
                content={widget}
                attribute="headline"
              />
              <Scrivito.ContentTag
                tag="h2"
                className="page-header-widget__sub-headline h3"
                content={widget}
                attribute="subHeadline"
              />
              <Scrivito.ContentTag
                className="page-header-widget__description"
                content={widget}
                attribute="description"
              />
              {destination && (
                <Scrivito.LinkTag
                  className={`page-header-widget__link btn bg-${
                    widget.get("buttonColor") || "yellow"
                  }`}
                  to={destination}
                >
                  {destination.title() || "Read more"}
                </Scrivito.LinkTag>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="container pt-0">
        <div className="breadcrumb-wrapper --page-mode" />
      </div>
    </>
  );
});
